import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import Navbar from '../components/layout/Navbar';
import Logo from '../components/brand/Logo';
import Icon from '../components/brand/Icon';
import './QRPayPage.css';

const QRPayPage = () => {
  const [params] = useSearchParams();
  const zone = params.get('zone');
  const amount = params.get('amount');
  const desc = params.get('desc') || 'Payment';

  const payUrl = zone
    ? `${window.location.origin}/zone?zone=${zone}`
    : `${window.location.origin}/zone`;

  const downloadQR = () => {
    const canvas = document.querySelector('#qr-canvas canvas');
    if (!canvas) return;
    const url = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = url;
    a.download = `rgv-smartpay-qr${zone ? `-zone-${zone}` : ''}.png`;
    a.click();
  };

  return (
    <div className="qrpay-page">
      <Navbar />
      <div className="qrpay-content container">
        {zone ? (
          /* Customer-facing payment QR */
          <div className="qrpay-scanner">
            <div className="qrpay-card">
              <div className="qrpay-logo"><Logo size="md" /></div>
              <h1>Scan to Pay</h1>
              {amount && (
                <div className="qrpay-amount">${parseFloat(amount).toFixed(2)}</div>
              )}
              <p className="qrpay-desc">{desc}</p>
              <div id="qr-canvas" className="qrpay-qr">
                <QRCodeCanvas value={payUrl} size={220} level="H" includeMargin />
              </div>
              <p className="qrpay-hint">Point your phone camera at this code to pay</p>
              <div className="qrpay-actions">
                <button className="btn btn-outline btn-sm" onClick={downloadQR}>Download QR</button>
                <Link to={payUrl} className="btn btn-primary btn-sm">Open Payment Page</Link>
              </div>
            </div>
          </div>
        ) : (
          /* Business QR code generator */
          <div>
            <div className="qrpay-header">
              <h1>QR Code Pay</h1>
              <p>Display this QR code at your business so customers can scan and pay from their phone.</p>
            </div>

            <div className="qrpay-grid">
              <div className="card qrpay-generate">
                <h2>Your Business QR Code</h2>
                <p className="qr-sub">This QR code links to your payment page. Print it or display it at your counter.</p>
                <div id="qr-canvas" className="qrpay-qr qrpay-qr-lg">
                  <QRCodeCanvas
                    value={`${window.location.origin}/zone`}
                    size={240}
                    level="H"
                    includeMargin
                  />
                </div>
                <div className="qrpay-url">{window.location.origin}/zone</div>
                <div className="qrpay-btn-row">
                  <button className="btn btn-primary" onClick={downloadQR}>Download PNG</button>
                  <button className="btn btn-outline" onClick={() => window.print()}>Print</button>
                </div>
              </div>

              <div className="qrpay-tips card">
                <h2>Tips for Using QR Codes</h2>
                <ul className="tips-list">
                  <li>
                    <span className="tip-icon"><Icon name="qr" size={20} /></span>
                    <div>
                      <strong>Print and display</strong>
                      <p>Print the QR code and laminate it for your counter, table, or storefront window.</p>
                    </div>
                  </li>
                  <li>
                    <span className="tip-icon"><Icon name="card" size={20} /></span>
                    <div>
                      <strong>Show on screen</strong>
                      <p>Display this page on a tablet at checkout so customers scan right from the screen.</p>
                    </div>
                  </li>
                  <li>
                    <span className="tip-icon"><Icon name="doc" size={20} /></span>
                    <div>
                      <strong>Add to receipts</strong>
                      <p>Include the QR code on paper receipts so customers can pay or tip digitally.</p>
                    </div>
                  </li>
                  <li>
                    <span className="tip-icon"><Icon name="link" size={20} /></span>
                    <div>
                      <strong>Link to a specific amount</strong>
                      <p>Use <Link to="/payment-link">Payment Links</Link> to create QR codes for a specific service price.</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QRPayPage;
